export default __webpack_public_path__ + "static/image-1-7f315fb3f69481d5d3cc2cc9e03eea2b.jpg";